// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DelegateGroupedNounImageVoteTable_wrapper__GLPLV","nounCell":"DelegateGroupedNounImageVoteTable_nounCell__QPC3S"};